import React from 'react'

function Hr() {
  return (
      <>
          <head>
              <title>نظام الموارد البشري</title>
              <meta name="description" content="نظام الموارد البشرية بواجهات سلسلة وسهلة الاستخدام" />
          </head>
          <div>
              <h1>حوّل إدارة موظفيك إلى تجربة ذكية</h1>
              <p>نظام الموارد البشرية من بروتك المتحدة صُمم لتبسيط عمليات:</p>
              <ol>
                  <li>إدارة الرواتب والحضور والانصراف.</li>
                  <li>تقييم الأداء وتتبع التدريبات.</li>
                  <li> تخزين ملفات الموظفين بشكل آمن وسري.</li>
              </ol>
              <p>
                  📊 كل ما تحتاجه لإدارة فريقك بكفاءة وأمان!</p>
          </div>
      </>
  )
}

export default Hr